import React from 'react';

import { useEarningsInsightsFilter } from '~/react-query-hooks/insights/useEarningsInsightsFilter';
import { parseEarningsInsights } from '~/react-query-hooks/insights/useEarningsInsightsFilter.utils';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { useSubscription } from '~/stores/use-subscription/useSubscription';
import { EarningsInsightPill } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/earnings-insight-pill/EarningsInsightPill';

import * as S from './EarningInsightsCell.styles';

interface EarningInsightsCellProps {
  earningsId: string;
  entityTag?: string;
}

export const EarningInsightsCell = ({
  earningsId,
  entityTag,
}: EarningInsightsCellProps) => {
  const isBasicOrLightUser = useSubscription(state =>
    state.isBasicOrLightUser()
  );

  const { data: earningsInsightsData = [], isFetching } =
    useEarningsInsightsFilter({
      body: { earnings_ids: [earningsId] },
      isEnabled: !isBasicOrLightUser,
    });
  const earningsInsight = parseEarningsInsights(earningsInsightsData);

  const hasData = !!earningsInsight && !isBasicOrLightUser && !!entityTag;

  if (isFetching) {
    return <S.StyledLoader />;
  }

  return hasData ? (
    <EarningsInsightPill
      entityTag={entityTag}
      earningsInsight={earningsInsight}
      isPreview={earningsInsight?.type === 'preview'}
      source={POSTHOG_TRACKING_SOURCES.EVENTS}
    />
  ) : null;
};
